import getWebShellClientLocale from "../../../../utils/get-webshellclient-locale";
import makeQueryKey from "../../../../utils/make-query-key";
var getPartnerCartReviewsQueryKey = function getPartnerCartReviewsQueryKey() {
  var country = getWebShellClientLocale().country;
  return makeQueryKey(['buy/partner_cart_reviews/v1', {
    country: country
  }]);
};
export default getPartnerCartReviewsQueryKey;